import React from "react";
import { Box, Typography } from "@mui/material";
import ActionsBtns from "../Components/ActionsBtns";
import EquipmentSelection from "./EquipmentSelection";
import Nav from "./Nav";
import { navItems } from "./navItemms";
import { useECSContext } from "../ecsContext";

export default function RequisitionTab({ name }) {
  const { currentMrqNav, currentPoNav, currentTab } = useECSContext();

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          p: 1,
          bgcolor: "white",
          fontSize: 18,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography>{name} | Equipment :</Typography>
          <EquipmentSelection />
        </Box>
      </Box>

      {/* Nav */}
      <Nav />

      {/* Content */}
      <Box
        sx={{
          height: 720,
          overflowY: "scroll",
          backgroundColor: "white",
          borderRadius: 2,
          p: 2,
          pt: 0,
        }}
      >
        {
          navItems.find((item) =>
            currentTab === 1
              ? currentMrqNav === item.label
              : currentPoNav === item.label
          ).panel
        }
      </Box>
    </Box>
  );
}
